<mat-form-field class="combo-search-select" appearance="outline">
  <mat-label>{{ label }}</mat-label>

  <mat-select class="combo-search-select__select"
              [attr.aria-label]="label || placeholder"
              [compareWith]="compararItens"
              [disabled]="estaDesabilitado"
              [multiple]="multiplaSelecao"
              [name]="nome"
              [ngModel]="valorInterno"
              [ngModelOptions]="{ standalone: true }"
              [placeholder]="placeholder"
              [required]="obrigatorio"
              (ngModelChange)="alterarValor($event)"
              (openedChange)="aoFecharPainel($event)"
              #select="ngModel">

    <mat-option class="combo-search-select__pesquisa">
      <ngx-mat-select-search
        [formControl]="controlePesquisa"
        [placeholderLabel]="placeholderPesquisa"
        [noEntriesFoundLabel]="mensagemSemResultados"
        [clearSearchInput]="false">
      </ngx-mat-select-search>
    </mat-option>

    <mat-option *ngIf="multiplaSelecao"
                class="combo-search-select__acoes">
      <div class="combo-search-select__botoes">
        <button type="button"
                mat-button
                color="primary"
                [disabled]="!itensFiltrados.length || todosSelecionados"
                (click)="marcarTodos($event)">
          Marcar todos
        </button>

        <button type="button"
                mat-button
                [disabled]="valorVazio"
                (click)="desmarcarTodos($event)">
          Desmarcar todos
        </button>
      </div>
    </mat-option>

    <mat-option *ngIf="permitirLimpar && !multiplaSelecao && !obrigatorio"
                [value]="null">
      {{ textoLimpar }}
    </mat-option>

    <mat-option *ngFor="let item of itensFiltrados; trackBy: trackByItem"
                [value]="item">
      <span [matTooltip]="itemToString(item)">
        {{ itemToString(item) }}
      </span>
    </mat-option>
  </mat-select>

  <mat-error *ngIf="select.hasError('required')">
    {{ errorMessage }}
  </mat-error>
</mat-form-field>
